(function () {
    'use strict';

    angular
        .module('app.layout')
        .factory('navRoutes', navRoutes);

    navRoutes.$inject = ['$state', 'routerHelper', 'userService'];

    /* @ngInject */
    function navRoutes($state, routerHelper, userService) {
        var states = routerHelper.getStates();
        var service = {
            getNavRoutes: getNavRoutes,
            isCurrent: isCurrent,
            getMobileNavRoutes: getMobileNavRoutes
        };

        return service;

        function getMobileNavRoutes() {
            return getNavRoutes(true);
        }

        function getNavRoutes(mobileOnly) {
            return states.filter(function (r) {
                var isLoggedIn = userService.isAuthenticated();
                var userType = userService.userType();
                var apiTypeId = userService.apiTypeId();
                
                if (!r.settings || !r.settings.nav) {
                    return false;
                }
                if (r.settings) {
                    if (r.settings.requireBillingDepartments) {
                        if (!userService.isCollegeNetApi()) {
                            var billingDepts = userService.billingDepartmentIds();
                            if (billingDepts.length == 0) {
                                return false;
                            }
                        }
                        else {
                            var numberPaymentTemplates = userService.numberOfPaymentTemplates();
                            if (numberPaymentTemplates == 0) {
                                return false;
                            }
                        }
                    }
                    if (r.settings.requireOps) {
                        if (userService.hasOps() == "0") {
                            return false;
                        }
                    }
                    if (r.settings.requireDataApi) {
                        if ( userService.hasDataApi() === "0") {
                            return false;
                        }
                    }
                    if (mobileOnly && !r.settings.mobileButton) {
                        return false;
                    }

                    var allowedUserTypes = r.settings.allowedUserTypes;
                    if (allowedUserTypes && allowedUserTypes.length > 0) {
                        if (!isLoggedIn) {
                            return false;
                        }
                        for (var i = 0; i < allowedUserTypes.length; i++) {
                            if (allowedUserTypes[i] == userType) {
                                return true;
                            }
                        }
                        return false;
                    }
                    var allowedApiTypes = r.settings.allowedApiTypes;
                    if (allowedApiTypes && allowedApiTypes.length > 0) {
                        if (!isLoggedIn) {
                            return false;
                        }

                        for (var i = 0; i < allowedApiTypes.length; i++) {
                            if (allowedApiTypes[i] == apiTypeId) {
                                return true;
                            }
                        }
                        return false;
                    }

                    if (r.settings.authMode || r.settings.authMode == 0) {
                        if (r.settings.authMode == 0) { //unauthenticated only
                            return !isLoggedIn;
                        }
                        else if (r.settings.authMode == 1) { //authenticated only
                            return isLoggedIn;
                        }
                        else {
                            return true;
                        }
                    }
  
                }

                return r.settings && r.settings.nav;
            }).sort(function (r1, r2) {
                return r1.settings.nav - r2.settings.nav;
            });
        }

        function isCurrent(route) {
            if (!route.title || !$state.current || !$state.current.title) {
                return '';
            }
            var menuName = route.title;
            return $state.current.title.substr(0, menuName.length) === menuName ? 'current' : '';
        }


    }
}());
